export default "__VITE_ASSET__pjRWXftT__"